import { Button1 } from './Button1';

/**
 * button_sms_code_pressed
 * тап на активную кнопку “Войти по смс”
 */
export interface ButtonSmsCodePressed {
  button: Button1;
}

export function mapButtonSmsCodePressedEvent(event: ButtonSmsCodePressed): object {
  const props: Record<string, unknown> = {
      button: event.button,
  };

  return {
    event: 'analytics_event',
    event_name: 'button_sms_code_pressed',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
